<template>
  <div>
    <v-card
      v-if="cardData"
      width="400px"
      :class="`pt-2 pl-3 ma-2 ${cardColor}`"
    >
      <v-card-title>
        <span
          >Site: {{ cardData.Description }}
          {{ cardData.Inactive ? ' (Inactive)' : '' }}
        </span>
        <v-spacer />
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon @click="editSiteClick">
              <v-icon :color="feature.sites.color" v-bind="attrs" v-on="on">
                {{ feature.sites.iconEdit }}
              </v-icon>
            </v-btn>
          </template>
          <span>Edit Site</span>
        </v-tooltip>
      </v-card-title>
      <v-card-text>
        <AddressCard
          :name="cardData.Address.Name"
          :street="cardData.Address.Street"
          :city="cardData.Address.City"
          :state="cardData.Address.State"
          :postCode="cardData.Address.PostCode"
        />
        <div>
          <div v-if="cardData.Supervisor" class="my-2 left">
            Supervisor:
            {{ cardData.Supervisor }}
          </div>
        </div>
        <ServicesCard
          :cardData="cardData"
          :readonly="!isServiceEditEnabled"
          @update="servicesCardUpdateEvent"
        />
        <ServiceablesCard
          v-if="cardData.ServiceableTypeList.length > 0"
          :cardData="cardData"
          @update="serviceablesCardUpdateEvent"
        />
      </v-card-text>
    </v-card>

    <v-dialog v-model="showSiteEditorDialog" :width="feature.sites.dialogWidth">
      <SiteEditor
        v-if="cardData"
        :isDialogOpen="showSiteEditorDialog"
        :customerId="cardData.CustomerId"
        :siteId="cardData.SiteId"
        :isDeleteEnabled="isDeleteEnabled"
        @close="siteEditorCloseEvent"
        @update="siteEditorUpdateEvent"
      />
    </v-dialog>
    <DialogUtil ref="dialogUtil" />
  </div>
</template>

<script>
import { ref, watch, computed } from 'vue'
import { feature } from '@/use/Constants'
import { host } from '@/services/HostAPI'
import AddressCard from '@/components/Common/AddressCard'
import ServicesCard from '@/components/ScheduledService/ServicesCard'
import ServiceablesCard from '@/components/Site/ServiceablesCard'
import SiteEditor from '@/components/Site/SiteEditor'
export default {
  name: 'SiteCard',
  props: {
    isDialogOpen: {
      type: Boolean,
      default: false
    },
    siteId: {
      type: String,
      required: true
    },
    isDeleteEnabled: {
      type: Boolean,
      default: false
    },
    isServiceEditEnabled: {
      type: Boolean,
      default: true
    }
  },
  components: {
    AddressCard,
    SiteEditor,
    ServicesCard,
    ServiceablesCard
  },
  setup(props, context) {
    const dialogUtil = ref(null)
    const showSiteEditorDialog = ref(false)
    const cardData = ref()

    watch(
      () => props.isDialogOpen,
      newVal => {
        newVal && initDialog()
      }
    )

    const initDialog = () => {
      loadData()
    }

    const loadData = async () => {
      const rq = { InfoId: props.siteId }
      const rs = await host.site.card(rq)

      if (!rs.IsSuccess) {
        dialogUtil.value.error(rs.Message)
        context.emit('close')
      }

      cardData.value = rs.Info
    }

    const editSiteClick = () => {
      showSiteEditorDialog.value = true
    }

    const siteEditorCloseEvent = () => {
      showSiteEditorDialog.value = false
    }

    const siteEditorUpdateEvent = () => {
      showSiteEditorDialog.value = false
      loadData()
    }

    const servicesCardUpdateEvent = () => {
      loadData()
    }

    const serviceablesCardUpdateEvent = () => {
      loadData()
    }

    const cardColor = computed(() => {
      return !cardData.value || cardData.value.Inactive
        ? 'red lighten-4'
        : 'light-green lighten-4'
    })

    initDialog()

    return {
      cardData,
      feature,
      editSiteClick,
      showSiteEditorDialog,
      siteEditorCloseEvent,
      siteEditorUpdateEvent,
      servicesCardUpdateEvent,
      serviceablesCardUpdateEvent,
      cardColor
    }
  }
}
</script>

<style lang="scss" scoped>
.left {
  float: left;
  width: 200px;
}
.right {
  float: right;
}
</style>
